module.exports = __webpack_public_path__ + "static/media/08.35a532e5.png";